import { Button, Heading, IconButton, LuIcon, Overlay, Separator } from "@overmap-ai/blocks"
import { selectDeletedRequests, selectOutboxActive, selectOutboxRequests } from "@overmap-ai/core"
import { Wifi, WifiOff } from "lucide-react"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import OutboxViewer from "../OutboxViewer/OutboxViewer"

export const OutboxButton = memo(function OutboxButton() {
	const deletedRequests = useAppSelector(selectDeletedRequests)
	const requests = useAppSelector(selectOutboxRequests)
	const active = useAppSelector(selectOutboxActive)

	const itemCount = requests.filter((request) => !deletedRequests.includes(request.request.uuid)).length

	return (
		itemCount > 0 && (
			<Overlay.Root>
				<Overlay.Trigger asChild>
					<Button aria-label="outbox" variant="fill" accentColor="base" size="sm">
						<LuIcon icon={active ? Wifi : WifiOff} />
						{active ? "Online" : "Offline"} {itemCount > 0 && itemCount}
					</Button>
				</Overlay.Trigger>
				<Overlay.Content title="Request outbox" className="overflow-hidden">
					<div className="flex size-full flex-col gap-4 overflow-hidden p-4">
						<div className="flex items-center justify-between gap-2">
							<Overlay.Title asChild>
								<Heading size="lg">Outbox</Heading>
							</Overlay.Title>
							<Overlay.Close asChild>
								<IconButton accentColor="base" variant="soft" size="md">
									<LuIcon icon={modelIconMapping.close} />
								</IconButton>
							</Overlay.Close>
						</div>
						<Separator size="full" />
						<OutboxViewer />
					</div>
				</Overlay.Content>
			</Overlay.Root>
		)
	)
})
OutboxButton.displayName = "OutboxButton"
